import Popup from './popup.js';

export default Popup;
